export default __webpack_public_path__ + "static/ActaDisplay-ExtraBold-e9ec38ec816206639d2e3a06e2e3fbea.woff2";